import { render, staticRenderFns } from "./schoolOrder.vue?vue&type=template&id=ef257f90&"
import script from "./schoolOrder.vue?vue&type=script&lang=js&"
export * from "./schoolOrder.vue?vue&type=script&lang=js&"
import style0 from "./schoolOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "schoolOrder.vue"
export default component.exports